import apiApp from "./index";

const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// ✅ Helper: build subTenantDTO
const getSubTenantDTO = () => {
  if (decodedToken?.isMultitenancy && decodedToken?.subTenantId) {
    return { id: decodedToken.subTenantId };
  }
  return null;
};

// ✅ Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") || decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const CompliantApi = {
  // Create Compliant Api
  CreateCompliant: (data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) {
      jsonData.subTenantDTO = subTenantDTO;
    }

    return apiApp
      .post(`/customerCompliant`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Create Compliant Reply Api
  CompliantReplay: (data) => {
    let jsonData = JSON.parse(data);

    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) {
      jsonData.subTenantDTO = subTenantDTO;
    }

    return apiApp
      .post(`/compliantReply`, JSON.stringify(jsonData), { headers: getHeaders() })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // List User Compliants
  ListUserCompliants: (Email) => {
    let filterType = "customerCompliant/createBy";
    if (Email === "admin@admin.com") {
      filterType = "customerCompliant";
    }

    return apiApp
      .get(
        `/${filterType}/${Email}?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // List Details Compliant
  CompliantDetails: (CompliantId) => {
    return apiApp
      .get(
        `/customerCompliant/details/${CompliantId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // List Replies for Compliant
  CompliantReplys: (CompliantId) => {
    return apiApp
      .get(
        `/compliantReply/compliant/${CompliantId}?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },

  // Delete Compliant
  DeleteCompliant: (CompliantId) => {
    return apiApp
      .delete(
        `/customerCompliant/${CompliantId}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error?.response?.data));
  },
};

export default CompliantApi;
